import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation();
  const { isAuthenticated, isLoading, user } = useAuthStore();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-gray-500">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  // Check if user account has been deleted
  if (user && user.status === 'deleted') {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="max-w-md mx-auto text-center p-6">
          <div className="text-red-600 text-5xl mb-4">⚠️</div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Account Deleted</h1>
          <p className="text-gray-700 mb-4">
            Your account has been deleted. You can no longer access this page.
          </p>
          <p className="text-sm text-gray-600">
            If you believe this is an error, please contact{' '}
            <a href="mailto:privacy@vistora.app" className="text-blue-600 hover:underline">
              privacy@vistora.app
            </a>
            .
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
